export default "__VITE_ASSET__c5212a1b__"